import React from 'react';
import { Box, Chip } from '@mui/material';

function normalizeSuggestion(suggestion, index) {
  if (!suggestion || typeof suggestion !== 'object') return null;
  const prompt = typeof suggestion.prompt === 'string' ? suggestion.prompt.trim() : '';
  if (!prompt) return null;
  const suggestionKey = suggestion.suggestion_key || suggestion.key || null;
  return {
    ...suggestion,
    prompt,
    suggestion_key: suggestionKey,
    key: `${suggestionKey || prompt}:${index}`,
  };
}

function suggestionPayload(suggestion) {
  const { key: _renderKey, ...payload } = suggestion;
  return payload;
}

export default function ChatMessageSuggestions({
  suggestions = [],
  disabled = false,
  onSendSuggestion,
}) {
  const visibleSuggestions = Array.isArray(suggestions)
    ? suggestions.map(normalizeSuggestion).filter(Boolean)
    : [];
  if (visibleSuggestions.length === 0) return null;

  return (
    <Box
      data-testid="chat-message-suggestions"
      sx={{
        display: 'flex',
        gap: 1,
        mt: 1,
        pb: 0.5,
        maxWidth: '100%',
        flexWrap: 'wrap',
      }}
    >
      {visibleSuggestions.map((suggestion) => (
        <Chip
          key={suggestion.key}
          label={suggestion.label || suggestion.prompt}
          variant="outlined"
          disabled={disabled}
          onClick={() => onSendSuggestion?.(suggestionPayload(suggestion))}
          sx={{
            height: 'auto',
            maxWidth: 360,
            borderRadius: '8px',
            '& .MuiChip-label': {
              py: 0.75,
              whiteSpace: 'normal',
            },
          }}
        />
      ))}
    </Box>
  );
}
